<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
// eslint-disable-next-line no-unused-vars
import NumerosaLetras from "../../../../helpers/numeros";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

/**
 * Products component
 */
// eslint-disable-next-line no-unused-vars
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      formPro: {
        direccionp: "",
        empleado: "",
        nit_cliente: "",
        no_orden: "",
        observaciones: "",
        fecha_compra: "",
        tienda: "",
        cliente: "",
        dias_vencimiento: "",
        totalPendiente: 0,
        totalPagado: 0,
        vendedor: "",
        total: "",
        state: true,
        id: 0,
      },
      estadoCredito: false,
      formFactura: {
        fecha_emision: "",
        fecha_certificacion: "",
        dataCert: "",
        serie: "",
        number: "",
        uuid: "",
      },
      detalleorden: [],
      title: "IMPRIMIR",
      items: [
        {
          text: "Cotización",
          href: "/",
        },
        {
          text: "Imprimir cotización",
          active: true,
        },
      ],
      detalleProducto : [],
      detalleServicio :[]
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  updated() {
    this.$refs["buttonImprimir"].click();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    letras(cantidad) {
      let a;
      a = NumerosaLetras(cantidad);
      return a;
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    quantity(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMMM DD [de] YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    detalle() {
      let me = this;
      axios
        .get(
          process.env.VUE_APP_URL +
            "ordenes/view?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          console.log(response);
          me.formPro.cliente = response.data.respuesta.vehiculo.cliente.persona.nombre_persona + ' ' + response.data.respuesta.vehiculo.cliente.persona.apellido_persona;
          me.formPro.auto = response.data.respuesta.vehiculo.modelo.auto.nombre_auto;
          me.formPro.modelo = response.data.respuesta.vehiculo.modelo.nombre_modelo;
          me.formPro.placas = response.data.respuesta.vehiculo.placa;
          me.formPro.anio = response.data.respuesta.vehiculo.anio;
          me.formPro.observaciones = response.data.respuesta.observacion_cliente;
          me.formPro.observaciones_mecanico = response.data.respuesta.observacion_mecanico;
          me.formPro.observacion_general = response.data.respuesta.observaciones;

          me.formPro.total = response.data.respuesta.total;
          me.formPro.saldo = response.data.respuesta.saldo_credito;
          me.formPro.fecha_entrada = response.data.respuesta.fecha_entrada;
          me.formPro.fecha_entrada = response.data.respuesta.fecha_entrada;
          me.formPro.no_servicio = response.data.respuesta.no_servicio;

          me.detalleProducto = response.data.respuesta.detalle_prod_servs;
          me.detalleServicio = response.data.respuesta.detalle_serv_servs;
          me.formPro.usuario = response.data.respuesta.user.empleado.persona.nombre_persona+' '+response.data.respuesta.user.empleado.persona.apellido_persona;
          me.formPro.sucursal = response.data.respuesta.tienda.nombre_tienda;
 
        //   console.log(me.detalleProducto, me.detalleServicio);
          
        
        });
    },
    calcularTotal() {
      let total = 0;
      this.detalleServicio.forEach(item => {
        total += item.subtotal_servicio;
      });
      return this.money(total);
    },
    calcularTotalRepuestos() {
      let total = 0;
      this.detalleProducto.forEach(item => {
        total += item.subtotal_venta;
      });
      return this.money(total);
    }
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
  },
};
</script>
<style></style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mt-4">
      <div class="col d-print-none">
        <router-link
          :to="{
            name: 'taller',
          }"
          class="btn text-muted d-none d-sm-inline-block btn-link"
        >
          <i class="mdi mdi-arrow-left me-1"></i>REGRESAR
        </router-link>
      </div>
      <div class="col d-print-none">
        <div class="float-end">
          <a
            ref="buttonImprimir"
            href="javascript:window.print()"
            class="btn btn-primary w-md waves-effect waves-light me-1"
            ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a
          >
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="watermark">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <img
                  class="img-fluid float-right"
                  src="../../../../../src/assets/mecanica1.jpg"
                  alt="Logo"
                  width="300" height="100"
                />
              </div>
              <div class="col">
                <h6>Taller de REPARACIÓN ARIEL</h6>
                <label
                  ><i class="bx bx-phone"></i>42837238</label
                ><br />
                <label
                  ><i class="bx bx-map"></i> Compa Jutiapa<br /> </label
                ><br />
                <h4>
                <strong>Cliente</strong>
                    <h6 >
                    <strong>Cliente:</strong> {{  formPro.cliente}} <br />
                    <strong>Vehiculo:</strong> {{ formPro.auto + ' ' + formPro.modelo + '::' + formPro.anio + '::'+formPro.placas }}<br />
                    <strong>Servicio No.:</strong>{{formPro.no_servicio }}<br />
                    <strong>Fecha Ingreso.:</strong>{{formPro.fecha_entrada }}
                </h6>
                </h4>
              </div>
            </div>
            <br />

            <hr style="color: black" />
            <h3>Mano de obra</h3>
            <div  style="display: flex; justify-content: space-between;">
              <table class="table" border="2" style="font-size: small">
                <thead>
                  <tr>
                    <th>
                      <i class="bx bxs-grid-alt"></i>&nbsp;&nbsp;Descripción
                    </th>
                    <th><i class="bx bx-list-ul"></i>&nbsp;&nbsp;Cantidad</th>
                    <th>
                      <i class="bx bx-purchase-tag-alt"></i>&nbsp;&nbsp;Precio
                      unitario
                    </th>
                    <th><i class="bx bx-money"></i>&nbsp;&nbsp;Monto</th>
                  </tr>
                </thead>
                <tbody>
                    <tr
                    v-for="(item, idx) in detalleServicio"
                    v-bind:key="idx"
                    style="font-size: small"
                  >
                  <td>{{ item.servicio.nombre_servicio }}</td>
                  <td>{{ quantity(item.cantidad_servicios) }} Unidad(es)</td>
                  <td>
                    {{ money(item.precio_servicio) }}
                  </td>
                    <td>
                      {{ money(item.subtotal_servicio) }}
                    </td>
                  </tr>
                 
                </tbody>
                
              </table>
          
            </div>    
            
            <div class="row">
                <div class="col" />
                <div class="col" />
                <div class="col" />
                <div class="col">
                  <h5><strong>Mano de obra</strong></h5>
                </div>
                <div class="col" align="right">
                  <h5>
                    <strong>
                      {{ calcularTotal() }}
                    </strong>
                  </h5>  
                </div>
            </div>  
            <hr style="color: black" />
            <h3>Repuestos y materiales</h3>
            <div>
              <table class="table" border="2" style="font-size: small">
                <thead>
                  <tr>
                    <th>
                      <i class="bx bxs-grid-alt"></i>&nbsp;&nbsp;Descripción
                    </th>
                    <th><i class="bx bx-list-ul"></i>&nbsp;&nbsp;Cantidad</th>
                    <th>
                      <i class="bx bx-purchase-tag-alt"></i>&nbsp;&nbsp;Precio
                      unitario
                    </th>
                    <th><i class="bx bx-money"></i>&nbsp;&nbsp;Monto</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, idx) in detalleProducto"
                    v-bind:key="idx"
                    style="font-size: small"
                  >
                  <td>{{ item.producto.nombre_producto }}</td>
                  <td>{{ quantity(item.cantidad_venta) }} Unidad(es)</td>
                  <td>
                    {{ money(item.precio_venta) }}
                  </td>
                    <td>
                      {{ money(item.subtotal_venta) }}
                    </td>
                  </tr>
                  
                </tbody>
              </table>
              <div class="row">
                <div class="col" />
                <div class="col" />
                <div class="col" />
                <div class="col">
                  <h5><strong>Repuestos y materiales</strong></h5>
                </div>
                <div class="col" align="right">
                  <h5>
                    <strong>
                      {{ calcularTotalRepuestos() }}
                    </strong>
                  </h5>  
                </div>
            </div>  
            <br>
            <br>
            <br>
              <div class="row">
                <div class="col" />
                <div class="col" />
                <div class="col" />
                <div class="col">
                  <h4><strong>Total final</strong></h4>
                </div>
                <div class="col" align="right">
                  <h4>
                    <strong>
                      {{ money(formPro.total > 0 ? formPro.total : 0.0) }}
                    </strong>
                  </h4>  
                </div>
                <div class="col" v-if="estadoCredito">
                  <h4><strong>Pendiente:</strong></h4>
                </div>
                <div class="col" align="right" v-if="estadoCredito">
                  <h4>
                    <strong>
                  {{ money(formPro.totalPendiente) }}
                    </strong>
                  </h4>  
                </div>
                <div class="col" v-if="estadoCredito">
                  <h4><strong>Adelanto:</strong></h4>
                </div>
                <div class="col" align="right" v-if="estadoCredito">
                  <h4>
                    <strong>
                      {{ money(formPro.totalPagado) }}
                    </strong>
                  </h4>  
                </div>


              </div>
              <br />
              <div class="row">
                <h6>
                  <strong> Valor en letras: </strong>{{ letras(formPro.total) }}
                </h6>

                <br />
                <p align="justify">
                  IMPORTANTE: Este presupuesto esta sujeto a variaciones de precios por diferentes circunstancias que puedan 
                  presentarse al momento de la reparación.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.fondo {
  background-color: #f05948;
}
/*
@media print {
  @page {
    margin: 10px;
    size: auto;
  }
}*/
</style>
